import React from "react";
import { getArbokOriginFullUrl } from "../../../../../utils/media.utils";
import { AiOutlineDownload } from "react-icons/ai";
import useTranslation from "../../../../../hooks/use-translation";
const Attachment = (props) => {
    const { message } = props;
    const { translate } = useTranslation();
    console.log('yes', message);
    return (React.createElement("div", { className: 'media-attachment__container' },
        React.createElement("div", { className: 'overlay' }),
        React.createElement("embed", { src: getArbokOriginFullUrl(message.uri), style: { overflow: "hidden" } }),
        React.createElement("a", { href: getArbokOriginFullUrl(message.uri), target: '_blank', download: true }),
        React.createElement("div", { className: 'download-button-container d-flex justify-content-center align-items-center' },
            React.createElement("div", { className: 'download-button' },
                React.createElement(AiOutlineDownload, { className: 'icon' }),
                React.createElement("div", null, translate("download"))))));
};
export default Attachment;
